import { render, staticRenderFns } from "./Selfie.vue?vue&type=template&id=1c23cbbc&scoped=true&"
import script from "./Selfie.vue?vue&type=script&lang=js&"
export * from "./Selfie.vue?vue&type=script&lang=js&"
import style0 from "./Selfie.vue?vue&type=style&index=0&id=1c23cbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23cbbc",
  null
  
)

export default component.exports